const getCompanyId = (supplier) => supplier?.CompanyId;

export default getCompanyId;
